import { TableField } from "../../table-field";

const nomeBanca: TableField = {
    key: "NomeBanca",
    label: "Nome",
    tdClass: ["align-middle", "quebrarPorPalavraHard"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const cnpjBanca: TableField = {
    key: "CnpjBanca",
    label: "CNPJ",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const foneBanca: TableField = {
    key: "FoneBanca",
    label: "Telefone",
    tdClass: ["align-middle", "naoQuebrar"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: true,
};
const actions = {
    key: "actions",
    label: "Ações",
    tdClass: ["align-middle", "col-actions"],
    thClass: ["text-center", "naoQuebrar"],
    sortable: false,
};

export const fieldsBancas: TableField[] = [
    nomeBanca,
    cnpjBanca,
    foneBanca,
    actions,
];
